import { useMsal } from "@azure/msal-react";
import { useState, useEffect } from "react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

const useAccessToken = (scopes = ["Mail.Send"]) => {
    const { instance, accounts } = useMsal();
    const [accessToken, setAccessToken] = useState(null);

    useEffect(() => {
        if (accounts.length > 0) {
            const request = {
                scopes: scopes,
                account: accounts[0], // Get the first signed-in account
            };

            instance
                .acquireTokenSilent(request)
                .then(response => {
                    setAccessToken(response.accessToken);
                })
                .catch(error => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenPopup(request).then(response => {
                            setAccessToken(response.accessToken);
                        }).catch(err => console.error("Token acquisition error:", err));
                    } else {
                        console.error("Silent token acquisition error:", error);
                    }
                });
        }
    }, [instance, accounts, scopes]);

    return accessToken;
};

export default useAccessToken;